/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */


import {FiHeadphones, FiBook, FiPenTool, FiMic, FiPieChart} from 'react-icons/fi'
export const AnalysisData=[
    {
        id:'userID1',
        scoreType:[
            { 
                name:"totalScore",
                icon: <FiPieChart/>,
                score:""
            }, 
            {   
                name:"readScore",
                icon: <FiBook />,
                score:""
            }, 
            {   
                name:"lisScore",
                icon: <FiHeadphones />,
                score:""
            }, 
            {   
                name:"wriScore",
                icon: <FiPenTool />,
                score:""
            }, 
            {   
                name:"speakScore",
                icon: <FiMic />,
                score:""
            }
        ]
    }
]

export const scoreType=[
    'Total Score', 'Read', 'Listen', 'Speak', 'Write'
]

export const grammarType=[
    "Grammar", "Fluent", "Pronounce", "Spell", "Vocabulary", "Express"
]
